import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f18b026a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18b026a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18b026a')) {
      api.createRecord('f18b026a', component.options)
    } else {
      api.reload('f18b026a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f18b026a&scoped=true", function () {
      api.rerender('f18b026a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/company/index.vue"
export default component.exports